import React, { useState, useEffect, useCallback } from "react";
import axios from "axios";
import { Modal, Button, Table, Form, Row, Col, InputGroup, FormControl } from "react-bootstrap";
import { usePortalScope } from "../context/PortalScopeContext";

const VendorActions = () => {
    const [vendors, setVendors] = useState([]);
    const [selectedVendor, setSelectedVendor] = useState(null);
    const [actions, setActions] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [newAction, setNewAction] = useState({
        Action: "",
        Remark: "",
    });
    const [searchQuery, setSearchQuery] = useState("");
    const api_url = process.env.REACT_APP_API_URL;
    const { scopeParam } = usePortalScope();
    const token = localStorage.getItem("token");

    const fetchVendors = useCallback(async () => {
        try {
            const response = await axios.get(`${api_url}/api/vendor${scopeParam}`, {
                headers: token ? { Authorization: `Bearer ${token}` } : {},
            });
            setVendors(response.data);
        } catch (error) {
            console.error("Error fetching vendors:", error);
        }
    }, [api_url, scopeParam, token]);

    useEffect(() => {
        fetchVendors();
    }, [fetchVendors]);

    const fetchActions = async (vendor) => {
        setSelectedVendor(vendor);
        try {
            const response = await axios.get(`${api_url}/api/vendorActions/${vendor.VendorId}`, {
                headers: token ? { Authorization: `${token}` } : {},
            });
            setActions(response.data);
            setShowModal(true);
        } catch (error) {
            console.error("Error fetching actions:", error);
        }
    };

    const handleAddAction = async (e) => {
        e.preventDefault();
        const currentDateTime = new Date();

        // Adjust the date to Sri Lanka time (UTC +5:30)
        const sriLankaTime = new Date(currentDateTime.toLocaleString("en-US", { timeZone: "Asia/Colombo" }));

        try {
            // Send the correct VendorId, newAction data, and the current Sri Lanka time as ISO string
            await axios.post(`${api_url}/api/vendorActions`, {
                VendorId: selectedVendor.VendorId,
                ...newAction,
                Date: sriLankaTime.toISOString(),
            }, {
                headers: token ? { Authorization: `Bearer ${token}` } : {},
            });
            fetchActions(selectedVendor);
            setNewAction({ Action: "", Remark: "" });
        } catch (error) {
            console.error("Error adding action:", error);
        }
    };

    const filteredVendors = vendors.filter(
        (vendor) =>
            vendor.CompanyName.toLowerCase().includes(searchQuery.toLowerCase()) ||
            vendor.Contact.toLowerCase().includes(searchQuery.toLowerCase())
    );

    return (
        <div className="container mt-4">
            <h2 className="text-center mb-4">Actions</h2>

            {/* Search Bar */}
            <InputGroup className="mb-4">
                <FormControl
                    placeholder="Search by company name or contact"
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                />
            </InputGroup>

            <Table striped bordered hover responsive>
                <thead className="table table-striped table-bordered">
                    <tr>
                        <th>Company Name</th>
                        <th>Name</th>
                        <th>Contact</th>
                        <th>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {filteredVendors.map((vendor) => (
                        <tr key={vendor.Id}>
                            <td>{vendor.CompanyName}</td>
                            <td>{vendor.FirstName} {vendor.LastName}</td>
                            <td>{vendor.Contact}</td>
                            <td>
                                <Button variant="primary" onClick={() => fetchActions(vendor)}>
                                    View Actions
                                </Button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </Table>

            <Modal
                show={showModal}
                onHide={() => setShowModal(false)}
                size="lg"
                centered
                backdrop="static"
                style={{ zIndex: 1051 }} // Custom z-index to ensure modal is above the overlay
            >
                <Modal.Header closeButton>
                    <Modal.Title>Actions for {selectedVendor?.CompanyName}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form onSubmit={handleAddAction}>
                        <Row>
                            <Col md={6}>
                                <Form.Group>
                                    <Form.Label>Action</Form.Label>
                                    <Form.Control
                                        type="text"
                                        value={newAction.Action}
                                        onChange={(e) => setNewAction({ ...newAction, Action: e.target.value })}
                                        required
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={6}>
                                <Form.Group>
                                    <Form.Label>Remark</Form.Label>
                                    <Form.Control
                                        type="text"
                                        value={newAction.Remark}
                                        onChange={(e) => setNewAction({ ...newAction, Remark: e.target.value })}
                                    />
                                </Form.Group>
                            </Col>
                        </Row>
                        <Button variant="success" type="submit" className="mt-3 w-100">
                            Add Action
                        </Button>
                    </Form>

                    <h5 className="mt-4">Previous Actions</h5>
                    <Table striped bordered hover>
                        <thead>
                            <tr>
                                <th>Action</th>
                                <th>Remark</th>
                                <th>Date & Time</th>
                            </tr>
                        </thead>
                        <tbody>
                            {actions.map((action) => (
                                <tr key={action.ActionId}>
                                    <td>{action.Action}</td>
                                    <td>{action.Remark || "N/A"}</td> {/* Show N/A if Remark is null */}
                                    <td>
                                        {new Date(action.Date).toLocaleString("en-US", {
                                            timeZone: "Asia/Colombo",
                                            year: 'numeric',
                                            month: 'numeric',
                                            day: 'numeric',
                                            hour: 'numeric',
                                            minute: 'numeric',
                                            second: 'numeric',
                                            hour12: true // To display in 12-hour format (AM/PM)
                                        })}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowModal(false)}>Close</Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
};

export default VendorActions;
